interface CpmToggleSwitchProps {
    checked: boolean;
    onChange: () => void;
    title?: string;
    disabled?: boolean;
    className?: string;
}

/** Design: 32×19 track, 15×15 knob — Excise Category Curation live toggle. */
export default function CpmToggleSwitch({
    checked,
    onChange,
    title,
    disabled = false,
    className = '',
}: CpmToggleSwitchProps) {
    return (
        <button
            type="button"
            title={title}
            disabled={disabled}
            aria-pressed={checked}
            onClick={(e) => {
                e.stopPropagation();
                if (!disabled) onChange();
            }}
            className={[
                'inline-flex items-center shrink-0 rounded-full transition-all duration-150 ease-out disabled:cursor-not-allowed disabled:opacity-50',
                className,
            ].join(' ')}
            style={{
                width: 32,
                height: 19,
                padding: '0 2px',
                background: checked ? 'var(--cpm-brand-purple)' : 'var(--cpm-border-strong)',
                cursor: disabled ? 'not-allowed' : 'pointer',
            }}
        >
            <span
                className="rounded-full bg-white"
                style={{
                    width: 15,
                    height: 15,
                    boxShadow: '0 1px 2px rgba(14,8,88,.3)',
                    marginLeft: checked ? 'auto' : 0,
                }}
            />
        </button>
    );
}
